import { Injectable } from "@angular/core";
import { Service } from "src/app/core/jsonapi/service";
import { WorkerGuardShift } from "../_types/worker-guard-shift";

@Injectable({
    providedIn: 'root',
})
export class WorkerGuardShiftsService extends Service<WorkerGuardShift> {
    public override type = 'workerGuardShifts';
    public override url = 'providers/workerGuardShifts';
}
